import { BaseSpace } from 'app/components/common/BaseSpace'
import styled from 'styled-components'

export const ContentWrapper = styled(BaseSpace)`
  width: 100%;
`